import {configureStore} from '@reduxjs/toolkit'
import tokenReducer, {TOKEN_STATE} from './token.js';
import merchantReducer, {MERCHANT_STATE} from './merchant.js';
import communeReducer, {COMMUNE_STATE} from "./commune";

const reducer = {};
reducer[TOKEN_STATE] = tokenReducer;
reducer[MERCHANT_STATE] = merchantReducer;
reducer[COMMUNE_STATE] = communeReducer;
const store = configureStore({
    reducer
});

// store.subscribe(() => {
// });
export default store;
const state = (reducer) => store.getState()[reducer];

export {state};